import { render, staticRenderFns } from "./special.vue?vue&type=template&id=7264d0fd&scoped=true&"
import script from "./special.vue?vue&type=script&lang=js&"
export * from "./special.vue?vue&type=script&lang=js&"
import style0 from "./special.vue?vue&type=style&index=0&id=7264d0fd&lang=sass&scoped=true&"
import style1 from "./special.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264d0fd",
  null
  
)

export default component.exports